<script setup lang="ts"></script>

<template>
  <div class="order-item-list">
    <slot />
  </div>
</template>

<style scoped>
  .order-item-list {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 4px;
    padding: 16px;
  }
</style>
